module.exports = __webpack_public_path__ + "static/media/profile.457f61f1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/screenshots/profile.png
 ** module id = 433
 ** module chunks = 0
 **/